import { IOrderItem, IDiscountItemMap } from '../../model/order.store'
import { includes, forEach } from 'lodash'
import { isBefore, isAfter } from 'date-fns'

/**
 * Chương trình sale đẩy mascarpone Savor Cake (theo ngày nhận 28/5 - 27/6/2026)
 * - Giảm 30k: nhóm Tiramisu sinh nhật/cốc + bánh kem whipping
 * - Giảm 20k: nhóm bánh hộp thiếc có mascarpone
 */

const MASCARPONE_30K_SKUS = [
  'V1850',
  'V1865',
  'V1880',
  'V10221',
  'V10238',
  'V9106',
  'V9108',
  'V9110',
  'V9065',
  'V9067',
  'V9069',
  'V10308',
  'V10309',
  'V9071',
  'V9073',
  'V9075',
  'V10310',
  'V10311',
  'V9707',
  'V9706',
  'V10917',
  'V10918'
]

const MASCARPONE_20K_SKUS = [
  'V9653',
  'V9968',
  'V9651',
  'V10115',
  'V10114',
  'V10465',
  'V10602',
  'V10605',
  'V10912',
  'V10911',
  'V10910',
  'V10909',
  'V9627',
  'V9628',
  'V10596',
  'V10598',
  'V9629',
  'V9652',
  'V9851',
  'V9969',
  'V9795',
  'V9794'
]

const MASCARPONE_30K_DISCOUNT = 30000
const MASCARPONE_20K_DISCOUNT = 20000

const DEADLINE_START = new Date('2026-05-28T00:00:00+07:00')
const DEADLINE_END = new Date('2026-06-27T23:59:59+07:00')

interface IProcessMascarponeDiscountParams {
  items: IOrderItem[]
  resultMap: IDiscountItemMap
  deadline: Date
}

export function processMascarponeDiscount({
  items,
  resultMap,
  deadline
}: IProcessMascarponeDiscountParams): void {
  if (isBefore(deadline, DEADLINE_START) || isAfter(deadline, DEADLINE_END)) {
    return
  }

  forEach(items, item => {
    if (includes(MASCARPONE_30K_SKUS, item.sku)) {
      resultMap[item.id].discount = Math.max(item.quantity * MASCARPONE_30K_DISCOUNT, 0)
      resultMap[item.id].saleProgram = 'Giảm giá bánh tiramisu và bánh kem whipping (Mas)'
      return
    }
    if (includes(MASCARPONE_20K_SKUS, item.sku)) {
      resultMap[item.id].discount = Math.max(item.quantity * MASCARPONE_20K_DISCOUNT, 0)
      resultMap[item.id].saleProgram = 'Giảm giá bánh hộp thiếc (Mas)'
    }
  })
}
